var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('input',{staticClass:"hidden",attrs:{"type":"radio","name":_vm.name,"id":_vm.value}}),_c('label',{class:((_vm.active ? 'bg-orange-pale border-orange-pale' : 'bg-transparent border-snow-200') + " flex items-center border rounded-lg px-4 py-8 h-16 cursor-pointer duration-300 w-full"),attrs:{"for":_vm.value},on:{"click":function () {
                _vm.$emit('click')
                _vm.$emit('select', _vm.value)
            }}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }